import React, { Component } from 'react'
import { formatName } from '../../../helpers'

const isShortAnswer = (text) => {
  return [1, 2, 3, 4, 5, 'yes', 'no'].indexOf(text) > -1
}

class UniqueVoteRow extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showPoll: false
    }
  }

  render () {
    const { vote, poll, player, team } = this.props

    return (
      <div className='vote-row'>
        <div className='vote-user'>
          <div className='vote-user-photo' style={{ background: `url(${player.avatar || '/imgs/default-avatar.png'}) center center / cover no-repeat` }} />
          <div className='user-info'>
            <div>{formatName(player.name)}</div>
            <div>{team && team.name}</div>
          </div>
        </div>
        <div
          className='question-info-container'
          onMouseEnter={() => poll.text.length > 50 && this.setState({ showPoll: true })}
          onMouseLeave={() => this.setState({ showPoll: false })}>
          <div className='bold-text'>
            {poll.title}
          </div>
          {poll.text.length > 50 ? poll.text.slice(0, 50) + '...' : poll.text}
        </div>
        <div className={`unique-answer ${isShortAnswer(vote.vote) && 'bold-text'}`}>
          {isShortAnswer(vote.vote) ? vote.vote.toString().toUpperCase() : vote.vote}
        </div>
        {this.state.showPoll &&
          <div
            className='question-info-container poll-modal'>
            <div className='bold-text'>
              {poll.title}
            </div>
            {poll.text}
          </div>}
      </div>
    )
  }
}

export default UniqueVoteRow



// WEBPACK FOOTER //
// ./src/components/common/popups/UniqueVoteRow.js